import { render, staticRenderFns } from "./TriggerForm.vue?vue&type=template&id=8e610180&scoped=true&"
import script from "./TriggerForm.vue?vue&type=script&lang=js&"
export * from "./TriggerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e610180",
  null
  
)

export default component.exports